import React, { useEffect, useState } from 'react';
import '../styles/SuggestLocationModal.css';

const SuggestLocationModal = ({ isOpen, onClose, onSubmit, city, status }) => {
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [category, setCategory] = useState('recreation');
    const [shortDescription, setShortDescription] = useState('');
    const [longDescription, setLongDescription] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Define categories to match the Sidebar filters
    const categories = [
        { value: 'documents', label: 'Documents' },
        { value: 'shops', label: 'Shops' },
        { value: 'restaurants', label: 'Restaurants' },
        { value: 'recreation', label: 'Recreation' },
        { value: 'cultural', label: 'Cultural' },
        { value: 'educational', label: 'Educational' },
    ];

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const locationData = Object.fromEntries(formData.entries());
        // Basic validation in component, more robust validation on backend
        if (!locationData.name || !locationData.address) {
            alert('Location name and address are required.');
            return;
        }
        onSubmit(city, locationData);
    };

    // --- Inline Styles for Buttons ---
    // Base style for both buttons to ensure consistency
    const baseButtonStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '44px',
        padding: '0 24px',
        borderRadius: '6px',
        border: '1px solid',
        fontSize: '1rem',
        fontWeight: '600',
        lineHeight: '1',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        whiteSpace: 'nowrap',
    };

    // Style for the cancel button
    const cancelButtonStyles = {
        ...baseButtonStyle,
        borderColor: '#dee2e6',
        backgroundColor: '#f1f3f5',
        color: '#495057',
    };

    // Style for the submit button
    const submitButtonStyles = {
        ...baseButtonStyle,
        borderColor: '#4CAF50',
        backgroundColor: '#4CAF50',
        color: 'white',
    };

    const disabledStyle = {
        cursor: 'not-allowed',
        opacity: 0.65,
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button onClick={onClose} className="modal-close-button">&times;</button>
                <h2>Suggest a New Location in {city.charAt(0).toUpperCase() + city.slice(1)}</h2>
                
                {status && status.message && (
                    <div className={`status-message ${status.type}`}>
                        {status.message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="suggestion-form">
                    <div className="form-group">
                        <label htmlFor="name">Location Name*</label>
                        <input type="text" id="name" name="name" required disabled={isLoading} onChange={(e) => setName(e.target.value)} value={name} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="address">Address*</label>
                        <input type="text" id="address" name="address" required disabled={isLoading} onChange={(e) => setAddress(e.target.value)} value={address} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="category">Category</label>
                        <select id="category" name="category" defaultValue="recreation" disabled={isLoading} onChange={(e) => setCategory(e.target.value)} value={category}>
                            {categories.map(cat => (
                                <option key={cat.value} value={cat.value}>{cat.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="shortDescription">Short Description (Max 150 chars)</label>
                        <textarea id="shortDescription" name="shortDescription" maxLength="150" disabled={isLoading} onChange={(e) => setShortDescription(e.target.value)} value={shortDescription}></textarea>
                    </div>
                     <div className="form-group">
                        <label htmlFor="longDescription">Why are you suggesting this place? (Your tip for other students)</label>
                        <textarea id="longDescription" name="longDescription" disabled={isLoading} onChange={(e) => setLongDescription(e.target.value)} value={longDescription}></textarea>
                    </div>
                    <div className="form-actions">
                        <button 
                            type="button" 
                            onClick={onClose} 
                            style={isLoading ? {...cancelButtonStyles, ...disabledStyle} : cancelButtonStyles} 
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            style={isLoading ? {...submitButtonStyles, ...disabledStyle} : submitButtonStyles}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Submitting...' : 'Submit Suggestion'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SuggestLocationModal;
